module.exports = __webpack_public_path__ + "static/media/42.58eae8bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/42.jpg
// module id = 603
// module chunks = 0